export const BASKET_REWARDS_ERROR_STATUS = {
  UNAVAILABLE: 'unable_to_add_rewards',
  UNABLE_TO_APPLY: 'basket_not_valid',
  /** chowly-api internal code 29 — the reward requires specific items not in the basket. */
  NO_MATCHING_REWARD_ITEM: 'no_matching_reward_item',
};
